(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/views/result.js') >= 0) return;  svs.modules.push('/components/numbergames/results/views/result.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.results=_svs.numbergames.results||{};
_svs.numbergames.results.templates=_svs.numbergames.results.templates||{};
svs.numbergames.results.templates.result = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "  <div id=\"lotto1ResultRegion\"></div>\n\n  <div class=\"grid-row gutter-xs-2 gutter-am-0\">\n    <div id=\"peppbubblesRegion\" class=\"col-am-10 col-am-offset-1 col-md-6 col-md-offset-3 col-xl-4 col-xl-offset-4\"></div>\n  </div>\n\n  <div id=\"lotto2ResultRegion\" class=\"lotto-2-result-region\"></div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "  <div id=\"resultDetailRegion\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"isLotto")||(depth0 && lookupProperty(depth0,"isLotto"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"productId") : depth0),{"name":"isLotto","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":12}}})) != null ? stack1 : "")
    + "\n<div id=\"addonResultRegion\"></div>\n";
},"useData":true});
Handlebars.partials['components-numbergames-results-result'] = svs.numbergames.results.templates.result;
})(svs, Handlebars);


 })(window);